import { render } from "./TaskListComponent.vue?vue&type=template&id=490f93eb"
import script from "./TaskListComponent.vue?vue&type=script&lang=js"
export * from "./TaskListComponent.vue?vue&type=script&lang=js"

import "./TaskListComponent.vue?vue&type=style&index=0&id=490f93eb&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__